import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { PageHero } from '../components/ui/PageHero';
import { Reveal } from '../components/ui/Reveal';
import { CtaBanner } from '../components/CtaBanner';
import { posts, postCategories } from '../data/posts';
import { images } from '../data/images';
import { EASE_OUT } from '../utils/motion';
export function Blog() {
  const [filter, setFilter] = useState('Tous');
  const filtered = filter === 'Tous' ? posts : posts.filter(p => p.category === filter);
  const [featured, ...rest] = filtered;
  return <>
      <PageHero label="Blog" title="Le blog achats & supply chain." description="Méthodes, retours d’expérience et analyses pour acheter mieux, négocier juste et piloter vos flux avec sérénité." image={images.port} data-id="element-464" data-mp="cz3trmnk906h" />

      <section className="bg-paper py-20 lg:py-28" data-id="element-465" data-mp="3bo1a4z7wg66j">
        <div className="mx-auto max-w-[1440px] px-5 sm:px-8" data-id="element-466" data-mp="3bn9fprq1gehu">
          <div className="flex flex-wrap gap-2" role="group" aria-label="Filtrer par catégorie" data-id="element-467" data-mp="224axnlz7leff">
            {postCategories.map(cat => <button key={cat} type="button" onClick={() => setFilter(cat)} aria-pressed={filter === cat} className={`relative rounded-lg px-4 py-2 text-sm transition-colors duration-150 ${filter === cat ? 'text-white' : 'text-ink hover:bg-ink/[0.06]'}`} data-id="element-468" data-mp="272cdly1c8xmo">
                {filter === cat && <motion.span layoutId="blog-filter" className="absolute inset-0 rounded-lg bg-ink" transition={{
              duration: 0.25,
              ease: EASE_OUT
            }} data-id="element-469" data-mp="1s7fyd0v43a03" />}
                <span className="relative" data-id="element-470" data-mp="1x46dnlz3e1kg">{cat}</span>
              </button>)}
          </div>

          <AnimatePresence mode="wait" data-id="element-471" data-mp="33ophtne8q21e">
            <motion.div key={filter} initial={{
            opacity: 0,
            y: 12
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0
          }} transition={{
            duration: 0.25,
            ease: EASE_OUT
          }} data-id="element-472" data-mp="38kn03z92digt">
              {featured && <Link to={`/blog/${featured.slug}`} className="group mt-12 grid gap-8 lg:grid-cols-12 lg:items-center lg:gap-14" data-id="element-473" data-mp="1ihw66gyx4hkn">
                  <div className="aspect-[16/10] overflow-hidden rounded-[28px] lg:col-span-7" data-id="element-474" data-mp="1djkx48gg6b3h">
                    <img src={featured.image} alt="" className="h-full w-full object-cover transition-transform duration-300 ease-out-strong group-hover:scale-[1.04]" data-id="element-475" data-mp="ptgt3zzck9by" />
                  </div>
                  <div className="lg:col-span-5" data-id="element-476" data-mp="zjjuookjavlw">
                    <p className="text-sm text-muted" data-id="element-477" data-mp="zkbi3c3z9n13">
                      À la une · {featured.category} · {featured.readTime}
                    </p>
                    <h2 className="mt-4 text-[clamp(1.7rem,3vw,2.5rem)] font-medium leading-tight tracking-tight transition-colors duration-150 group-hover:text-brass-dark" data-id="element-478" data-mp="70wffps7yasq">
                      {featured.title}
                    </h2>
                    <p className="mt-4 leading-relaxed text-muted" data-id="element-479" data-mp="2dodbw2mvkezl">{featured.excerpt}</p>
                    <p className="mt-6 text-sm" data-id="element-480" data-mp="2iihk0p7vmt29">{featured.date}</p>
                  </div>
                </Link>}

              {rest.length > 0 && <ul className="mt-20 grid gap-x-8 gap-y-14 md:grid-cols-2 lg:grid-cols-3" data-id="element-481" data-mp="28sepgkl3x71t">
                  {rest.map((post, i) => <li key={post.slug} data-id="element-482" data-mp="2weuwtl1gu6ae" data-mpi={i}>
                      <Reveal delay={0.05 * i} data-id="element-483" data-mp="31gkal8g2oy26">
                        <Link to={`/blog/${post.slug}`} className="group flex h-full flex-col" data-id="element-484" data-mp="31f96f7iptoaj">
                          <div className="aspect-[4/3] overflow-hidden rounded-[22px]" data-id="element-485" data-mp="2nfztcgpt3aas">
                            <img src={post.image} alt="" className="h-full w-full object-cover transition-transform duration-300 ease-out-strong group-hover:scale-[1.05]" data-id="element-486" data-mp="2sdsxz5bgnw8y" />
                          </div>
                          <p className="mt-5 text-sm text-muted" data-id="element-487" data-mp="1h1iczl2yl4f2">
                            {post.category} · {post.readTime}
                          </p>
                          <h3 className="mt-2 text-xl font-medium leading-snug transition-colors duration-150 group-hover:text-brass-dark" data-id="element-488" data-mp="1rilzklxf7c1j">
                            {post.title}
                          </h3>
                          <p className="mt-3 line-clamp-2 leading-relaxed text-muted" data-id="element-489" data-mp="1ijgz3a2at8mq">{post.excerpt}</p>
                        </Link>
                      </Reveal>
                    </li>)}
                </ul>}

              {!featured && <p className="mt-12 text-muted" data-id="element-490" data-mp="268067m9m3fd8">Aucun article dans cette catégorie pour le moment.</p>}
            </motion.div>
          </AnimatePresence>
        </div>
      </section>

      <CtaBanner data-id="element-491" data-mp="21b1f7cl8voj9" />
    </>;
}